import { useState } from 'react';

export const useLatestVersion = () => {
  const [checkedLatestVersion, setCheckedLatestVersion] = useState<boolean>(() =>
    Boolean(localStorage.getItem('doc_latest_version'))
  );

  const changeLatestVersionProp = () => {
    if (localStorage.getItem('doc_latest_version')) {
      localStorage.removeItem('doc_latest_version');
      setCheckedLatestVersion(false);
    } else {
      localStorage.setItem('doc_latest_version', 'true');
      setCheckedLatestVersion(true);
    }
  };

  return {
    checkedLatestVersion,
    setCheckedLatestVersion,
    changeLatestVersionProp,
  };
};
